/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2024, Zumper
 */

import { Button, Flex, Image } from '@chakra-ui/react'
import React, { type Dispatch, type SetStateAction, useCallback } from 'react'
import chevronLeft from '../../icons/chevronLeft.svg'
import chevronLeftInactive from '../../icons/chevronLeftInactive.svg'
import chevronRight from '../../icons/chevronRight.svg'
import chevronRightInactive from '../../icons/chevronRightInactive.svg'

export const PageContentCarousel = ({
  currentPage,
  setCurrentPage,
  totalPages,
}: {
  currentPage: number
  setCurrentPage: Dispatch<SetStateAction<number>>
  totalPages: number
}) => {
  const pageDown = useCallback(() => {
    setCurrentPage(currentPage - 1)
  }, [currentPage, setCurrentPage])
  const pageUp = useCallback(() => {
    setCurrentPage(currentPage + 1)
  }, [currentPage, setCurrentPage])

  const pageDownButtonActive = currentPage > 0
  const pageUpButtonActive = currentPage < totalPages - 1

  return (
    <Flex>
      <Button
        aria-label="Previous page"
        mr={0}
        height="40px"
        width="40px"
        variant="outline"
        borderRadius="50%"
        borderColor="gray.150"
        onClick={pageDownButtonActive ? pageDown : () => {}}
        disabled={!pageDownButtonActive}
        cursor={pageDownButtonActive ? 'pointer' : 'default'}
        _active={
          pageDownButtonActive
            ? {
                background: 'gray.200',
              }
            : {
                background: 'white',
                borderColor: 'gray.150',
              }
        }
        _hover={
          pageDownButtonActive
            ? {
                background: 'gray.50',
                borderColor: 'gray.800',
              }
            : {
                background: 'white',
                borderColor: 'gray.150',
              }
        }
      >
        <Image
          minWidth="8px"
          minHeight="12px"
          transform="translateX(-2px)"
          src={pageDownButtonActive ? chevronLeft : chevronLeftInactive}
        />
      </Button>
      <Button
        aria-label="Next page"
        mr={0}
        ml="12px"
        height="40px"
        width="40px"
        variant="outline"
        borderRadius="50%"
        borderColor="gray.150"
        onClick={pageUpButtonActive ? pageUp : () => {}}
        cursor={pageUpButtonActive ? 'pointer' : 'default'}
        disabled={!pageUpButtonActive}
        _active={
          pageUpButtonActive
            ? {
                background: 'gray.200',
              }
            : {
                background: 'white',
                borderColor: 'gray.150',
              }
        }
        _hover={
          pageUpButtonActive
            ? {
                background: 'gray.50',
                borderColor: 'gray.800',
              }
            : {
                background: 'white',
                borderColor: 'gray.150',
              }
        }
      >
        <Image
          minWidth="8px"
          minHeight="12px"
          transform="translateX(1px)"
          src={pageUpButtonActive ? chevronRight : chevronRightInactive}
        />
      </Button>
    </Flex>
  )
}
